<script>
import { onMount } from "svelte";
import Select from "./Select.svelte"; 
import { systemFonts, googleFonts } from './fontNames'
import { v4 as uuidv4} from "uuid";
import { Debug } from "../../debugger";
import { State } from '../../store'

export let fontValue = "apple-system, inherit"
export let weightValue = ""
export let key = ""

let systemValues = ["apple-system, inherit", ... systemFonts]
let systemLabels = ['Inherit', ... systemFonts]


$: font = {
    family: fontValue ?? "",
    variant: weightValue ?? "",
    inUse: true
};

$: {
    if (googleFonts.includes(fontValue)) {
        $State.fonts[key] = font
    } else {
        font.inUse = false
        $State.fonts[key] = font
    }
}

</script>

<div class="input-wrap">
    <select class="inspector" bind:value={fontValue}>
        <optgroup label="Apple System">
            {#each systemValues as v, i}
                <option value={v}>{systemLabels[i]}</option>
            {/each}
        </optgroup>
        <optgroup label="Google Fonts">
            {#each googleFonts as v, i}
                <option value={v}>{googleFonts[i]}</option>
            {/each}
        </optgroup>
    </select>

    <Select bind:value={weightValue} values={['','100','200','300','400','500','600','700','800','900']} labels={['Weight','100','200','300','400','500','600','700','800','900']}></Select>

</div>

<style>

select {
    border:none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -ms-appearance: none; /* get rid of default appearance for IE8, 9 and 10*/
    /* margin-left: -10px; */
    /* padding-left: 10px; */
}

</style>